var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7323_382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5C3.58897 0.5 0 4.08897 0 8.5C0 12.911 3.58897 16.5 8 16.5C12.411 16.5 16 12.911 16 8.5C16 4.08897 12.411 0.5 8 0.5ZM12.4712 6.39474L7.3584 11.4674C7.05764 11.7682 6.57644 11.7882 6.25564 11.4875L3.54887 9.0213C3.22807 8.72055 3.20802 8.2193 3.48872 7.8985C3.78947 7.57769 4.29073 7.55764 4.61153 7.8584L6.75689 9.82331L11.3283 5.25188C11.6491 4.93108 12.1504 4.93108 12.4712 5.25188C12.792 5.57268 12.792 6.07393 12.4712 6.39474Z",
    fill: "#00B71D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7323_382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnable);
export default __webpack_public_path__ + "static/media/enable.f4cd5a93f59a0ce2506174c870a9c05e.svg";
export { ForwardRef as ReactComponent };